import {
    type ELEMENT_TYPES,
    type LeadElement,
    type TitleElement,
    type TitleHeaderElement,
} from '@@editor/helpers/Element';

export const HEADING_ELEMENT_IDS = new Map<
    typeof ELEMENT_TYPES.TITLE_HEADER | typeof ELEMENT_TYPES.TITLE | typeof ELEMENT_TYPES.LEAD,
    TitleHeaderElement['id'] | TitleElement['id'] | LeadElement['id']
>();
